import { gql } from '@apollo/client';
import operationResultFragment from '../../../shared/queries/operationResultFragment';

const MOVE_USER_LICENSE_TO_ORG_UNIT = gql`
  mutation MoveUserLicenseToOrgUnit($userLicenseInfo: MoveUserLicenseToOrgUnitInput!) {
    moveUserLicenseToOrgUnit(userLicenseInfo: $userLicenseInfo) {
      ...OperationResultFields
    }
  }
  ${operationResultFragment}
`;

export default MOVE_USER_LICENSE_TO_ORG_UNIT;
